import React from 'react';
import { Device } from '../../lib/types';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface RecallDeviceModalProps {
  open: boolean;
  onClose: () => void;
  device: Device | null;
  onRecall: (deviceId: string) => void;
}

export default function RecallDeviceModal({ open, onClose, device, onRecall }: RecallDeviceModalProps) {
  if (!device) {
    return null;
  }

  // const currentDevice = device;
  const { holderName, holderType, id, petName } = device;
  const isFoster = holderType === 'foster';
  const title = isFoster ? 'Recall device' : 'Unlink device';

  const message = isFoster
    ? `Recall ${id}${petName ? ` (${petName})` : ''} from ${
        holderName
      }? The foster will be notified to return the device.`
    : `Unlink ${id} from ${petName || 'this pet'}? The device will remain in your rescue's inventory.`;

  function handleConfirm() {
    onRecall(id);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>{title}</ModalTitle>
      <ModalSubtitle>{message}</ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          {isFoster ? 'Recall Device' : 'Unlink Device'}
        </Button>
      </ModalActions>
    </Modal>
  );
}
